<template>
  <button
    class="button"
    :class="{
      'button--primary': primary,
      'button--disabled': disabled,
      'button--white': white,
      'button--loading': loading
    }"
    v-on="$listeners"
    v-bind="$attrs"
    :disabled="disabled"
    type="button"
  >
    <slot />

    <img
      v-if="loading"
      src="~@/assets/icons/loading-indicator.gif"
      width="30"
      class="ml-20 img-loading"
    />
  </button>
</template>

<script>
export default {
  name: "VButton",
  props: {
    primary: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    white: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped lang="scss">
@import "../styles/variables";

.button {
  border: none;
  font-size: 13px;
  padding: 12px 40px;
  text-transform: uppercase;
  font-weight: bold;
  letter-spacing: 1.25px;
  display: inline-flex;
  cursor: pointer;
  border-radius: 3px;
  align-items: center;
  outline: none;
  svg,
  img {
    margin: 0 -17px 0 14px;
    &.icon-left {
      margin: 0 16px 0 -17px;
    }
    &.img-loading {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translateX(-50%) translateY(-50%);
      margin: 0;
      z-index: 11;
    }
  }

  &--loading {
    position: relative;
    &::after {
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      right: 0;
      background: rgba(255, 255, 255, 0.9);
      z-index: 10;
      content: "";
    }
  }

  &--primary {
    background: $color-primary;
    color: $color-white;
  }

  &--disabled {
    cursor: default;
    background: $color-lightgrey;
    color: $color-medium-grey;
    svg {
      * {
        fill: $color-medium-grey;
      }
    }
  }
  &--white {
    background: #fdfdfd;
    color: #d15421;
    border: 1px solid #ececec;
    padding-top: 11px;
    padding-bottom: 11px;
  }
  &--white-border {
    background: #fdfdfd;
    color: #d15421;
    border: 1px solid #ececec !important;
    padding-top: 10px;
    padding-bottom: 10px;
    margin: 0 10px 0 auto;
    padding: 10px 24px;
  }
  input[type="file"] {
    display: none;
  }
}
</style>
